var $81877e065529dfa7$exports = {};
$81877e065529dfa7$exports = {
    "valid": `Va\u{17E}e\u{107}e`
};


export {$81877e065529dfa7$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
